
 var managerArray = [];
(function($) {
  var searchBody = null; 
  //var domElement = null;

  $(function() {
    
    var isInit=false;    
    
    // Initialize Manager for presenting search results
    var Manager = new AjaxSolr.Manager();

    // Result widget
    Manager.addWidget(new AjaxSolr.ResultWidget({
      id: 'result',
	  name: "#docs",
      target: '#docs'
    }));

    // Pager widget
    Manager.addWidget(new AjaxSolr.PagerWidget({
      id: 'pager',
	  name: "#pager",
      target: '#pager',
      prevLabel: '&lt;',
      nextLabel: '&gt;',
      innerWindow: 1,
      renderHeader: function(perPage, offset, total,uniqueCod) {
        $('.' + uniqueCod + ' #pager-header').html($('<span></span>').text(String.format(get_message_string(393),Math.min(total, offset + 1),Math.min(total, offset + perPage),total)));
        // $('#pager-header').html($('<span></span>').text('displaying ' + Math.min(total, offset + 1) + ' to ' + Math.min(total, offset + perPage) + ' of ' + total));
      }
    }));

    // Category selector
    Manager.addWidget(new AjaxSolr.TagcloudWidget({
      id: 'type',
	  name: "#type",
      target: '#type',
      field: 'form'
    }));
    
    Manager.init();

    $('form#topSearchContainer ,form.searchContainer').submit(function (e) {
      e.preventDefault();
      e.stopPropagation();
      var $this = $(this);
      var inputtext = $("input:first",$this).val();
      if (inputtext) {
		  var uniqueCod = "cod" + getNextDomID();
           managerArray[uniqueCod] = Manager.newRequest(inputtext,uniqueCod);
      }
      if ($(e.target).hasClass('searchContainer')) {
          $('form#topSearchContainer input[type="text"]').val(inputtext);
      }  
    });

    launchEntity = function($selected) {
      var sel = $selected.data();
      if (!sel) return;
      startEnt(sel.form, sel.name, sel.dname, 5);
    };
	
    $('.searchInput')
    .bind('keydown', function(e) {

      // Escape from search
      if (e.keyCode == 27) {
        hide_search_popup();
      }

     // Called for every keydown in the search box
	   var code = e.keyCode || e.which;
      if (code == 13) {
        e.preventDefault();
        e.stopPropagation();
		var evtobj = window.event ? event : e;
        if (evtobj.ctrlKey) {
          launchEntity($("li.ui-state-focus a b"));
          //$(this).autocomplete("close");
        } else {
          if (this.value)  {
		  $(this).autocomplete("close");
            $('form#topSearchContainer input[type="text"]').val(this.value);
			Manager.newRequest(this.value);
            // When starting new search remove all filters and add filter 'all'
            $('.range-filters').removeClass('checked');
            $('.range-filters:first-child').addClass('checked');
          }
        }
      }
    })
    .autocomplete({
      delay: 500,
      minLength: 2,
      html: true,
      
      source: function(request, responseHandler) { // Called by jQuery UI for every keydown
        callbacks.ESearchAcCallback = $.proxy(function(data) {
          // Callback, called from GWT when autocomplete results are received
          var result = [];
          var myjson = JSON.parse(data);
          data = myjson.response.docs;
          for (var i = 0; i < data.length; i++) {
            var d = data[i];
            var showACText = (d.ac_text1) && (d.ac_text1 !== d.name);
            var input = showACText ? 
              d.ac_text1 : 
              d.name;
            
            var show = input + "&nbsp;" + "<span>" + getBPMName(d.form);
            if(showACText) show += " (" + d.name + ")"
            show += "</span> ";
            show += "<span class=\"ctrlEnter\">" + get_message_string(390) + "</span>";
            var label = $('<b/>', { html: show })
              .click(function () {
                launchEntity($(this));
              }).data(d);
            
            /* The label property is displayed in the suggestion menu. The value will be inserted 
               into the input element when a user selects an item.  */
            result.push({label: label, value: input});
          }
          responseHandler(result);
           
        }, this);

        window.esearchAutocomplete(request.term, getNextDomID()); // Magic API for autocomplete
      }
    });
	
  function bindSearchFiltersStrings(uniqueCod) {
    $('.' + uniqueCod + ' #entity').text(get_message_string(394));
    $('.' + uniqueCod + ' #rangeFilters').text(get_message_string(1242));
    $('.' + uniqueCod + ' #filterAll').text('הכל');
    $('.' + uniqueCod + ' #filter24h').text(get_message_string(1243));
    $('.' + uniqueCod + ' #filterWeek').text(get_message_string(1244));
    $('.' + uniqueCod + ' #filterMonth').text(get_message_string(1245));
    $('.' + uniqueCod + ' #filterYear').text(get_message_string(1246));
    $('.' + uniqueCod + ' #filterCustom').text(get_message_string(1247));
    $('.' + uniqueCod + ' #filterdatepickerFrom_' + uniqueCod).text(get_message_string(1248));
    $('.' + uniqueCod + ' #filterdatepickerTo_' + uniqueCod).text(get_message_string(1249));
    $('.' + uniqueCod + ' #filterAll').text(get_message_string(391));
    $('.' + uniqueCod + ' #customeSearch').attr('value', get_message_string(1250));
  }

  function setDateFilters(uniqueCod) {
	 
          today = new Date().getTime(),
          // specDate <== to convert dates to/from Priority (GOD given number! much better then 42! priority birthbay! number from Kabbalah)
          specDate = 567986400000,  
          specToday = Math.round((today - specDate )/ 60000);

        function addDays(days) {
          var result = new Date();
          result.setDate(result.getDate() + days);
          return result;
        }

        // Listening to the UL for better performance (Event Delegation)
        $('.' + uniqueCod + ' .range-list').on('click', function(e) {
			 var _manager;
			managerArray.forEach(function(element, index, array) {
				if (element.id == uniqueCod) {
					_manager = array[index].manager;
					return true;
				}
			})
          var $targetItem = $(e.target).parent(),
            $filterType = $(e.target).attr('value');
           
          console.log('$targetItem', $targetItem);
          console.log("e.target", e.target);

          initInputMask();

          if ($targetItem.get(0).tagName === 'LI') {

            $('.' + uniqueCod + ' .range-filters').removeClass('checked');
            $targetItem.toggleClass('checked');
            // _manager.fq = null; 
            // _manager.store["fq"] = "";
            if ($filterType === 'all') { 
              _manager.store['fromDate'] = 0;
              _manager.store['toDate'] = 0;
            } else if ($filterType === '24h') {
              _manager.store['fromDate'] = Math.round((addDays(-1) - specDate)/ 60000);
              _manager.store['toDate'] = specToday;
            } else if ($filterType === 'week') {
              _manager.store['fromDate'] = Math.round((addDays(-7) - specDate)/ 60000);
              _manager.store['toDate'] = specToday;
            } else if ($filterType === 'month') {
              _manager.store['fromDate'] = Math.round((addDays(-30)  - specDate)/ 60000);
              _manager.store['toDate'] = specToday;
            } else if ($filterType === 'year') {
              _manager.store['fromDate'] = Math.round((addDays(-365)  - specDate)/ 60000);
              _manager.store['toDate'] = specToday;
            }
            else
            {
              return;
            }
             
            // Clean custom filters on sending new search request
            $('.' + uniqueCod + ' .hasDatepicker').val("");
            $('.' + uniqueCod + ' .custom-range').addClass("hidden");
            _manager["timeFilter"] = true;
            _manager.store['start'] = 0;
            _manager.doRequest(null,uniqueCod);
          }

        });

        /* Custom range functions for jQuery UI */
		//bug fix for multiply event call for click
		last_click_time = new Date().getTime();
        $('.' + uniqueCod + ' #customRange').on('click', function(e) {
			click_time = new Date().getTime();//e['timeStamp'];
			if (click_time && (click_time - last_click_time) > 500) {
			  $('.' + uniqueCod + " .datepicker").toggleClass('hidden');
			}
			last_click_time = click_time;
        });

		function getFormat() {
			if(systemLanguage == 1){
				return 'dd/mm/yy';
			}
			else{
				return 'mm/dd/yy';
			}
		};
		
        function initInputMask(){
              //init inputmask date
              if(!isInit){
                  var dateMaskFrom,dateMaskFromNameAttr,dateMaskTo,dateMaskToNameAttr,format,errorMessage="";
              format=getDtFormat(0);
              dateMaskFromNameAttr=$(".hasDatepicker").first().attr("name");
              dateMaskToNameAttr=$(".hasDatepicker").last().attr("name");
              //var dateMask = new InputMask(JST_MASK_DATE, "date");
              if(systemLanguage == 1){
                  errorMessage="תאריך לא חוקי: ${value}. פורמט רצוי: ${mask}";
                  dateMaskFrom = new DateMask("dd/MM/yyyy", dateMaskFromNameAttr);
                  dateMaskTo = new DateMask("dd/MM/yyyy", dateMaskToNameAttr);
			}
			else{
                $("#ui-datepicker-div").addClass("en");
                errorMessage="Invalid date: ${value}. Expected format: ${mask}";
                dateMaskFrom = new DateMask("MM/dd/yyyy", dateMaskFromNameAttr);
                dateMaskTo = new DateMask("MM/dd/yyyy", dateMaskToNameAttr);
			}   
            dateMaskFrom.validationMessage = errorMessage;
            dateMaskTo.validationMessage = errorMessage;  
            isInit=true;
              }
              
        }
        
       	$(function() {
			$("#datepickerFrom_" + uniqueCod).datepicker({
				changeMonth: true,
				changeYear: true,
				numberOfMonths: 1,
				dateFormat: getFormat(),
				onClose: function(selectedDate) {
				$("#datepickerTo_" + uniqueCod).datepicker("option", "minDate", selectedDate);
				}
			});
			$("#datepickerTo_" + uniqueCod).datepicker({
				changeMonth: true,
				changeYear: true,
				numberOfMonths: 1,
				dateFormat: getFormat(),
				onClose: function(selectedDate) {
				$("#datepickerFrom_" + uniqueCod).datepicker("option", "maxDate", selectedDate);
				}
			});
		});


        function setCustomDateFilter() {
          
      // Listener that checks current system language and change dates format in Custom filter
      $('.' + uniqueCod + ' #customeSearch').on('click', function() {
        var customFrom,
          customTo;

        if (systemLanguage == "1") {
  			 customFrom = $.datepicker.parseDate("dd/mm/yy", $("#datepickerFrom_" + uniqueCod).val()).getTime();
  			 customTo = $("#datepickerTo_" + uniqueCod).val() ? $.datepicker.parseDate("dd/mm/yy", $("#datepickerTo_" + uniqueCod).val()).getTime() : today;
        } else {
             customFrom = $.datepicker.parseDate("mm/dd/yy", $("#datepickerFrom_" + uniqueCod).val()).getTime();
            // If there is a date in "to" input - parse it, if it's empty toDate = today
            customTo = $("#datepickerTo_" + uniqueCod).val() ? $.datepicker.parseDate("mm/dd/yy", $("#datepickerTo_" + uniqueCod).val()).getTime() : today;
        }
			
        managerArray.forEach(function(element, index, array) {
  			if (element.id == uniqueCod) {
  				self = array[index].manager;
  				return true;
  			}
		  })

			self.store['fromDate'] = Math.round(Math.round((customFrom - specDate) / 60000) / 1440) * 1440;
			self.store['toDate'] = Math.round(Math.round((customTo - specDate) / 60000) / 1440) * 1440;
			self["timeFilter"] = true;
          // self.fq = null; 
          // self.store["fq"] = "";
          self.doRequest(null,uniqueCod); 
        });            
      }

      setCustomDateFilter();   

  };
    
    // Set GWT callback for displaying search results
    callbacks.ESearchFindCallback = function(data,id) {
		var searchID = id;
        $.get(baseUrl+"/ng/views/search-popup.html", function(html) {
			searchBody = html;
			//var domElement = startDomHtml(get_message_string(94) + " - " + $('#esquery').val(), html, "80");
			var windowID = searchID;
			var _this;
			var _thisIndex;
			managerArray.forEach(function(element, index, array) {
				if (element.windowID == searchID ) {
					_this = array[index].manager;
					_thisIndex = array[index].id;
					return true;
				}
			})
			if(searchID != -1){
				//update existed search 
				//var uniqueCod = Manager.widgets.result.target.split(' ')[0].substring(1);
				searchBody = searchBody.replace("popupContent","popupContent " + _thisIndex);
				searchBody = searchBody.replace(/datepickerFrom/g,"datepickerFrom_" + uniqueCod);
				searchBody = searchBody.replace(/datepickerTo/g,"datepickerTo_" + uniqueCod);
				//var domElement = setDomInnerHtml( domElement, searchBody);
				setDomInnerHtml(null, searchBody);
				buildSearchResults(searchBody,_thisIndex);
			}else{
				//new search
				windowID = getNextDomID();
				var uniqueCod = "cod" + windowID;
				searchBody = searchBody.replace("popupContent","popupContent " + uniqueCod);
				searchBody = searchBody.replace(/datepickerFrom/g,"datepickerFrom_" + uniqueCod);
				searchBody = searchBody.replace(/datepickerTo/g,"datepickerTo_" + uniqueCod);
				var domElement = startDomHtml(windowID,get_message_string(1295) + " - " + $('#esquery').val(), searchBody, "80",0,undefined,false);
				setDomInnerHtml(domElement, searchBody);
				setButtonsPanelHtml("")
				buildSearchResults(searchBody,uniqueCod);
				managerArray.push({id : uniqueCod, manager : jQuery.extend(true, {}, Manager),windowID : getID(domElement)});
			}
        });
     
      function buildSearchResults(searchBody,uniqueCod) {
        Manager.handleResponse(JSON.parse(data),uniqueCod);
        bindSearchFiltersStrings(uniqueCod);
        setDateFilters(uniqueCod);
      }
    } // callback END

    String.format = function () {
      // The string containing the format items (e.g. "{0}")
      // will and always has to be the first argument.
      var theString = arguments[0];

      // start with the second argument (i = 1)
      for (var i = 1; i < arguments.length; i++) {
        // "gm" = RegEx options for Global search (more than one instance)
        // and for Multiline search
        var regEx = new RegExp("\\{" + (i - 1) + "\\}", "gm");
        theString = theString.replace(regEx, arguments[i]);
      }

      return theString;
    }   
  });
})(jQuery);